import Vue from 'vue'
import { loadStore } from './store'
import { registerErrorHandler } from './helpers/debugging'
import { registerGlobalComponents } from './helpers/components'
import { getRouter } from './helpers/nav'
import './style/app.scss'
import './helpers/validation-helper' // Auto-validate HTML syntax

Vue.config.productionTip = false

// Focus management for keyboard vs mouse navigation
if (typeof window !== 'undefined') {
  const handleFirstTab = (e) => {
    if (e.key === 'Tab') {
      document.body.classList.add('user-is-tabbing')
      window.removeEventListener('keydown', handleFirstTab)
      window.addEventListener('mousedown', handleMouseDownOnce)
    }
  }

  const handleMouseDownOnce = () => {
    document.body.classList.remove('user-is-tabbing')
    window.removeEventListener('mousedown', handleMouseDownOnce)
    window.addEventListener('keydown', handleFirstTab)
  }

  window.addEventListener('keydown', handleFirstTab)
}

registerErrorHandler(Vue)
registerGlobalComponents(Vue)
loadStore(async store => {
  const { default: App } = await import('./App.vue')
  const rootView = new Vue({ router: getRouter(), store, render: h => h(App) })
  
  rootView.$mount('#app')
})